import FormField from './FormField';
import InputTextarea from '../Inputs/InputTextarea';
import React from 'react';

export default class FieldTextarea extends React.Component {
	render() {
		return (
			<FormField
				className={this.props.className}
				help={this.props.help}
				inputName={this.props.id ?? this.props.name}
				label={this.props.label}
				labelClass={this.props.labelClass}
				required={this.props.required}
			>
				<InputTextarea
					autocomplete={this.props.autocomplete}
					className={this.props.inputClass}
					disabled={this.props.disabled}
					id={this.props.id ?? this.props.name}
					maxLength={this.props.maxLength}
					name={this.props.name ?? this.props.id}
					onBlur={this.props.onBlur}
					onChange={this.props.onChange}
					placeholder={this.props.placeholder}
					required={this.props.required}
				/>
			</FormField>
		);
	}
}

FieldTextarea.defaultProps = {
	disabled: false,
	required: false,
};
